import Reveal from "./Reveal";
import { IMAGES, whatsappLink } from "@/constants/site";

const CARDS = [
  {
    image: IMAGES.stairs,
    alt: "Yüksek ahşap tavan ve A-frame mimarisi",
    title: "Özgün Mimari",
    text: "A-frame mimarisi ve yüksek ahşap tavanlarıyla alışılmış konaklama deneyiminin dışında bir atmosfer.",
  },
  {
    image: IMAGES.living,
    alt: "Sıcak ahşap yaşam alanı ve kanepeler",
    title: "Sıcak Yaşam Alanları",
    text: "Ahşap dokular, ferah yaşam alanları ve doğaya açılan manzaralar.",
  },
  {
    image: IMAGES.livingStove,
    alt: "Doğaya açılan geniş pencereler ve soba",
    title: "Doğanın İçinde",
    text: "Güne doğanın sesleriyle başlayabileceğiniz sakin ve özel bir ortam.",
  },
];

export default function BungalowExperience() {
  const waLink = whatsappLink(
    "Merhaba Düzbağ Life, bungalov konaklama hakkında bilgi almak istiyorum."
  );

  return (
    <section id="bungalovlar" className="w-full bg-background-950">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <Reveal className="max-w-3xl">
          <span className="text-accent-400 text-xs tracking-[0.3em] uppercase">
            Düzbağ Life Bungalovları
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-background-50 leading-[1.15] font-medium">
            AHŞABIN SICAKLIĞI
            <br />
            DOĞANIN HUZURUYLA BULUŞUYOR
          </h2>
          <p className="mt-6 text-background-300 text-base md:text-lg leading-relaxed">
            Her bungalov, doğanın içinde kendinize ait bir alan yaratmanız için
            tasarlandı. Yüksek ahşap tavanlar, geniş pencereler ve asma kat
            mimarisiyle konfor ve doğa bir arada.
          </p>
        </Reveal>

        {/* Cards */}
        <div className="mt-14 flex gap-5 overflow-x-auto pb-4 lg:grid lg:grid-cols-3 lg:overflow-visible snap-x snap-mandatory">
          {CARDS.map((card, index) => (
            <Reveal
              key={card.title}
              delay={index * 100}
              className="min-w-[280px] sm:min-w-[360px] lg:min-w-0 snap-start"
            >
              <article className="group h-full bg-background-900 rounded-lg overflow-hidden border border-background-800">
                <div className="w-full h-[260px] md:h-[300px] overflow-hidden">
                  <img
                    src={card.image}
                    alt={card.alt}
                    title="Düzbağ Life bungalov iç mekan"
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-2xl text-background-50 font-medium">
                    {card.title}
                  </h3>
                  <div className="mt-3 h-px w-10 bg-accent-500" />
                  <p className="mt-4 text-background-300 text-sm leading-relaxed">
                    {card.text}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="mt-12">
          <a
            href={waLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 font-semibold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-whatsapp-line text-lg" />
            Konaklama İçin Bilgi Al
          </a>
        </Reveal>
      </div>
    </section>
  );
}